var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SeriesContainer',{staticClass:"serie"},[(_vm.strokeVisible)?_c('path',{attrs:{"d":_vm.paths.base,"fill":"none","stroke":_vm.stroke(_vm.dataProps),"stroke-width":_vm.strokeWidth,"stroke-dasharray":_vm.strokeDashedArray}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }